
export const downloadContact = () => {
  const vcard = `BEGIN:VCARD
VERSION:3.0
N:Rohini;Trupti;;;
FN:Trupti Rohini
ORG:Hirwai Landscape
TITLE:Landscape Design Company
TEL;TYPE=CELL:+919175932372
EMAIL:hirwailandscapers@gmail.com
URL:https://hirwai.com
NOTE:Crafting Green Dreams - Professional landscape design and maintenance services
ADR;TYPE=WORK:;;Hirwai Landscape Location (See: https://maps.app.goo.gl/2NbS5Da1qLhr7YbE8);;;;
END:VCARD`;
  
  const element = document.createElement("a");
  const file = new Blob([vcard], { type: "text/vcard" });
  element.href = URL.createObjectURL(file);
  element.download = "Hirwai_Contact.vcf";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};